// extracted by mini-css-extract-plugin
export var arrow = "dropdown-module--arrow--1MqkY";
export var content = "dropdown-module--content--8J9QD";
export var item = "dropdown-module--item--gC3Wm";
export var trigger = "dropdown-module--trigger--AGjQ9";